import { render, staticRenderFns } from "./sale-view-form.component.vue?vue&type=template&id=2859ee6d&"
import script from "./sale-view-form.component.ts?vue&type=script&lang=ts&"
export * from "./sale-view-form.component.ts?vue&type=script&lang=ts&"
import style0 from "./sale-view-form.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports